module.exports = __webpack_public_path__ + "img/degisning.aee25c39.png";